module.exports = __webpack_public_path__ + "static/img/2.8ad1f2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/2.png
// module id = CG4G
// module chunks = 0